<template>
  <page-header-wrapper @back="back">
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('用户ID')" prop="userId">
                <a-input v-model="queryParam.userId" :maxLength="16" :placeholder="$t('请输入')+$t('用户ID')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('手机号')" prop="mobile">
                <a-input v-model="queryParam.mobile" :maxLength="16" :placeholder="$t('请输入')+$t('手机号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('邮箱')" prop="email">
                <a-input v-model="queryParam.email" :maxLength="16" :placeholder="$t('请输入')+$t('邮箱')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="groupBy==='buyerId'">
              <a-form-item :label="$t('昵称')" prop="nickName">
                <a-input v-model="queryParam.nickName" :maxLength="16" :placeholder="$t('请输入')+$t('昵称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="groupBy==='raiseId'">
              <a-form-item :label="$t('真实姓名')" prop="realName">
                <a-input v-model="queryParam.realName" :maxLength="16" :placeholder="$t('请输入')+$t('真实姓名')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="16" :sm="24">
              <a-form-item :label="$t('商品名称')" prop="selectedGoodsIdList">
                <a-select mode="multiple" :placeholder="$t('请选择')+$t('商品名称')" style="width: 100%" v-model="queryParam.selectedGoodsIdList" @change="selectedGoodsChange" allowClear>
                  <a-select-option v-for="(item, index) in activityGoodsList" :value="item.id" :key="index">
                    {{ item.goodsName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <a-form-item :label="$t('SKU')" prop="skuIdList">
                <a-select mode="multiple" :placeholder="$t('请选择')+'SKU'"  style="width: 100%" v-model="queryParam.skuIdList" allowClear>
                  <a-select-option v-for="(item, index) in selectGoodsSkuList" :value="item.id" :key="index">
                    {{ item.goodsName }}/  {{ item.skuName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('下单开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                               :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('下单结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                               :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                               valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8 || 24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
                </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
        <div class="table-operations">
          <a-button type="primary" :disabled="multiple"  @click="handleSend()">
            <a-icon type="bell" />{{$t('发送消息')}}
          </a-button>
          <a-button type="primary" @click="handleExport" >
            <a-icon type="download" />{{$t('导出')}}
          </a-button>
        </div>
      </div>
      <a-tabs v-model="groupBy" @tabClick="changeTab" >
        <a-tab-pane key="buyerId" :tab="$t('按用户ID')"/>
      </a-tabs>
      <notice-user ref="noticeUser"/>

      <!-- 数据展示 -->
      <a-table v-if="groupBy==='buyerId'"
               :loading="loading"
               :size="tableSize"
               rowKey="userId"
               :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
               @change="handleSortChange"
               :columns="userColumns"
               :data-source="list"
               :pagination="false">
        <span slot="createTime" slot-scope="text, record">
            {{ parseTime(record.createTime) }}
          </span>
        <template slot="avatar" slot-scope="text, record">
          <div>
            <img v-if="record.avatar" :src="record.avatar"  style="width:60px;height:62px;" @click="handleRecordPreview(record.avatar)" alt="none"/>
          </div>
        </template>
        <span slot="nation" slot-scope="text, record">
           <custom-dict-tag :options="customDict.UserNationEnum" :value="record.nation"/>
        </span>
        <div slot="orderRaiseResult" slot-scope="text, record">
          <span>{{record.orderRaiseResult==null?null:record.orderRaiseResult.realName}}</span>
          <span>{{record.orderRaiseResult==null?null:record.orderRaiseResult.idCard}}</span>
          <span>{{record.orderRaiseResult==null?null:record.orderRaiseResult.mobile}}</span>
        </div>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {getActivityGoodsList, getActivityGoodsSkuList} from '@/api/activity/activity'
import {mapGetters} from 'vuex'
import moment from 'moment';
import CustomDictTag from "@/components/DictCustomTag";
import {translation} from "@/api/tool/common";
import {tableMixin} from '@/store/table-mixin'
import NoticeUser from '@/views/activity/activity/modules/NoticeUser'
import events from "@/components/MultiTab/events";
import {getGoodsRank, getRaiseRank} from "@/api/statistics/goods";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    NoticeUser
  },
  mixins: [tableMixin],
  data () {
    return {
      id: null,
      groupBy: 'buyerId',
      open:false,
      formTitle: null,
      list: [],
      activityGoodsList: [],
      activityGoodsSkuList: [],
      selectGoodsSkuList: [],
      pageSizeOptions: ['10', '30', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        activityId: this.id,
        goodsId: undefined,
        selectedGoodsIdList:[],
        goodsIdList: [],
        skuId: undefined,
        skuIdList: [],
        mobile: undefined,
        nickName: undefined,
        email: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      userColumns: [
        {
          title: this.$t('用户ID'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'userId',
          align: 'center'
        },
        {
          title: this.$t('昵称'),
          dataIndex: 'nickName',
          align: 'center'
        },
        {
          title: this.$t('头像'),
          dataIndex: 'avatar',
          scopedSlots: {customRender: 'avatar'},
          align: 'center'
        },
        {
          title: this.$t('邮箱'),
          dataIndex: 'email',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品数量'),
          dataIndex: 'goodsCount',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('订单数量'),
          dataIndex: 'orderCount',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        // {
        //   title: this.$t('应募信息'),
        //   scopedSlots: {customRender: 'orderRaiseResult'},
        //   dataIndex: 'orderRaiseResult',
        //   align: 'center'
        // },
        {
          title: this.$t('收货区域'),
          scopedSlots: {customRender: 'nation'},
          dataIndex: 'nation',
          align: 'center'
        },
        {
          title: this.$t('收货人姓名'),
          dataIndex: 'realName',
          align: 'center'
        },
        {
          title: this.$t('收货人手机号'),
          dataIndex: 'addressMobile',
          align: 'center'
        },
        // {
        //   title: this.$t('应援地址'),
        //   dataIndex: 'address',
        //   align: 'center'
        // },
      ],

      raiseColumns: [
        {
          title: this.$t('用户ID'),
          dataIndex: 'userId',
          align: 'center'
        },
        {
          title: this.$t('真实姓名'),
          dataIndex: 'realName',
          align: 'center'
        },
        {
          title: this.$t('手机号'),
          dataIndex: 'mobile',
          align: 'center'
        },
        {
          title: this.$t('身份证'),
          dataIndex: 'idCard',
          align: 'center'
        },
        {
          title: this.$t('邮箱'),
          dataIndex: 'email',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品数量'),
          dataIndex: 'goodsCount',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('订单数量'),
          dataIndex: 'orderCount',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title: this.$t('收货人姓名'),
          dataIndex: 'addressName',
          align: 'center'
        },
        {
          title: this.$t('收货人手机号'),
          dataIndex: 'addressMobile',
          align: 'center'
        },
        {
          title: this.$t('应援地址'),
          dataIndex: 'addressDetail',
          align: 'center'
        },
      ]
    };
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
    let id = this.$route.query.id
    if (id) {
      this.handleRank(id)
    }
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询活动记录列表 */
    getList () {
      if (this.queryParam.selectedGoodsIdList.length === 0) {
        this.queryParam.goodsIdList = this.activityGoodsList.map(item => item.id)
      } else {
        this.queryParam.goodsIdList = this.queryParam.selectedGoodsIdList
      }
      this.loading = true;
      if (this.groupBy === 'buyerId') {
        getGoodsRank(this.queryParam).then(response => {
          this.list = response.data.records
          this.total = response.data.total
          this.loading = false
        });
      } else {
        getRaiseRank(this.queryParam).then(response => {
          this.list = response.data.records
          this.total = response.data.total
          this.loading = false
        });
      }
    },
    //切换tab
    changeTab(index) {
      if (index == null) {
        index = undefined;
      }
      this.groupBy = index;
      this.getList();
    },
    async getActivityGoodsList() {
      this.loading = true
      this.queryParam.activityId = this.id
      await getActivityGoodsList(this.queryParam).then(response => {
        this.activityGoodsList = response.data
      })
      return this.activityGoodsList
    },
    getActivitySkuList () {
      this.loading = true
      this.queryParam.activityId=this.id
      getActivityGoodsSkuList(this.queryParam).then(response => {
        this.activityGoodsSkuList = response.data
        this.selectGoodsSkuList = response.data;
      })
    },
    selectedGoodsChange() {
      if (this.queryParam.selectedGoodsIdList.length === 0) {
        this.selectGoodsSkuList = this.activityGoodsSkuList
      }else {
        let skuList =[]
        this.activityGoodsSkuList.forEach(e => {
          if (this.queryParam.selectedGoodsIdList.includes(e.goodsId)) {
            skuList.push(e)
          }
        });
        this.selectGoodsSkuList = skuList;
      }

    },
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        activityId: this.id,
        goodsId: undefined,
        skuId: undefined,
        skuIdList: [],
        selectedGoodsIdList:[],
        goodsIdList: [],
        mobile: undefined,
        nickName: undefined,
        email: undefined,
        createBeginTime:undefined,
        createEndTime:undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1

    },
    limitMaxNum(sort) {
      let val = sort;
      if(val==null||val==undefined||val==''|| val<0){
        val=0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.limitNum = val
    },
    handleGoodsDelete(key) {
      const dataSource = [...this.form.goodsList];
      this.form.goodsList = dataSource.filter(item => item.id !== key);
    },
    /*text 要翻译的字段*/
    getTranslation(record) {
      if (!this.form.activityName && !this.form.posterTxt) {
        return;
      }
      let data = {"text": this.form.activityName, "locale": record.locale};
      translation(data).then(response => {
        record.activityName = response.data
      })
      let data2 = {"text": this.form.posterTxt, "locale": record.locale};
      translation(data2).then(response => {
        record.posterTxt = response.data
      })
    },
    limitSort(sort) {
      let val = sort;
      if(val==null||val==undefined||val==''|| val<0){
        val=0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.sort = val
    },


    getCategoryNameById(id) {
      if (!id) {
        return "";
      }
      let cateInfo = this.categoryList.find(e => e.id === id);
      if (cateInfo) {
        return cateInfo.categoryName
      } else {
        return "";
      }
    },

    getCateList() {
      listCategory().then(response => {
        this.categoryList = response.data;
        const cate = { id: "0", categoryName: this.$t('根节点'), children: [] }
        cate.children = this.handleTree(response.data, 'id','pid')
        this.cateOptions.push(cate)
      })
    },
    getBrandList() {
      allBrand().then(response => {
        this.brandList = response.data
      })
    },
    getBrandNameById(id) {
      if (!id) {
        return "";
      }
      let brandInfo = this.brandList.find(e => e.id === id);
      if (brandInfo) {
        return brandInfo.name
      } else {
        return "";
      }
    },
    async handleRank(id) {
      this.id = id;
      this.open = true;
      this.formTitle = this.$t('排行')
      //查询这个活动的sku
      this.getActivitySkuList()
      //查询这个活动的商品,
      let activityGoodsList = await this.getActivityGoodsList()
      console.log('活动商品名称', activityGoodsList);
      //查询列表
      this.getList()
    },
    handleSend () {
      this.$refs.noticeUser.handleAdd(this.selectedRows,this.id);
    },
    back() {
      let pages = this.$store.pages;
      pages.indexOf(this.$route)
      events.$emit('close', pages.indexOf(this.$route))
      // 去更新列表页的数据
      this.$router.push({path: '/activity/activity', replace: true, query:{}  })
    },


    /** 导出按钮操作 */
    handleExport () {
      var that = this;

      if (this.groupBy === 'buyerId') {
        this.$confirm({
          title: this.$t('是否确认导出'),
          content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
          onOk () {
            that.download('statistics/goods/user/rank/export',
              that.queryParam
              , `用户_${new Date().getTime()}.xlsx`)
          },
          onCancel () {}
        })
      } else {
        this.$confirm({
          title: this.$t('是否确认导出'),
          content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
          onOk () {
            that.download('statistics/goods/raise/rank/export',
              that.queryParam
              , `应募_${new Date().getTime()}.xlsx`)
          },
          onCancel () {}
        })
      }
    },

  }
}
</script>
